import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    search = '',
    filters = [],
    order = [],
    count = -1,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.depCate.getList, {
        search,
        filters,
        order,
        count,
    }, options);
    if (error) return { error, status };
    return content || { rows: [] };
};
